import { render, staticRenderFns } from "./MdLabelCN.vue?vue&type=template&id=23034be0&"
import script from "./MdLabelCN.vue?vue&type=script&lang=js&"
export * from "./MdLabelCN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports